// @flow

import * as React from 'react';
import {Handle, Position} from 'react-flow-renderer';

import {range} from 'lodash';
import Box from 'sail/Box';
import {Heading} from 'sail/Text';
import './SequenceDiagram.scss';
import {ACTOR_NODE_SECTION_HEIGHT} from './SequenceDiagram';

// TODO(adreyfus): Remove these hardcoded values when we update docs Sail colors
const COLORS = ['#3EA50B', '#FF8F0E', '#0055BC', '#635BFF'];

type SequenceDiagramActorNodeSectionProps = {|
  id: string,
  index: number,
  height: number,
  color: ?string,
|};

const SequenceDiagramActorNodeSection = ({
  id,
  index,
  color,
  height,
}: SequenceDiagramActorNodeSectionProps) => {
  const handleStyles = {top: '100%'};
  return (
    <Box
      className="SequenceDiagramActorNode-section"
      style={{height: `${height * 100}%`}}
    >
      {color && (
        <Box
          className="SequenceDiagramActorNode-section-highlight"
          style={{
            backgroundColor: color,
          }}
        />
      )}
      <Handle
        type="target"
        id={`${id}-${index}-left`}
        position={Position.Left}
        style={handleStyles}
      />
      <Handle
        type="source"
        position={Position.Left}
        id={`${id}-${index}-left`}
        style={handleStyles}
      />
      <Handle
        type="target"
        id={`${id}-${index}-right`}
        position={Position.Right}
        style={handleStyles}
      />
      <Handle
        type="source"
        position={Position.Right}
        id={`${id}-${index}-right`}
        style={handleStyles}
      />
    </Box>
  );
};

type SequenceDiagramActorNodeData = {|
  heading: React.Node,
  index: number,
  rows: number,
  highlights: Array<number>,
|};

type SequenceDiagramActorNodeProps = {|
  id: string,
  data: SequenceDiagramActorNodeData,
|};

export const SequenceDiagramActorNode = ({
  id,
  data,
}: SequenceDiagramActorNodeProps) => {
  const {heading, index, highlights, rows} = data;
  // Add one to the total number of rows so we have some visual bottom padding on the diagram
  const height = rows + 1;
  return (
    <Box
      className="SequenceDiagramActorNode"
      style={{height: `${ACTOR_NODE_SECTION_HEIGHT * height}px`}}
    >
      <Box
        flex={{alignItems: 'center'}}
        className="SequenceDiagramActorNode-heading"
      >
        <Box
          className="SequenceDiagramActorNode-heading-highlight"
          style={{
            background: `${COLORS[index] || 'black'}`,
          }}
        />
        <Heading>{React.Children.toArray(heading)}</Heading>
      </Box>
      {range(1, height + 1).map((i) => (
        <SequenceDiagramActorNodeSection
          key={`SequenceDiagramActorNodeSection-${i}`}
          id={id}
          index={i}
          height={1 / height}
          color={highlights && highlights.includes(i) ? COLORS[index] : null}
        />
      ))}
    </Box>
  );
};
